

class Alerter {

	constructor() {
		this.listener = null;
	}

	setListener(listener) {
		this.listener = listener;
	}

	showError(error) {
		if (this.listener != null)
			this.listener.onError(error);
	}

	showSuccess(success) {
		if (this.listener != null)
			this.listener.onSuccess(success);	
	}

	showInfo(info) {
		if (this.listener != null)
			this.listener.onInfo(info);	
	}

}

export default new Alerter();